import React from 'react';
import PropTypes from 'prop-types';

import Checkbox from '@visa/vds-react/checkbox-styled';

import SectionHeader from './sectionHeader.component';

const DropdownMultiselect = ({
  children,
  selectedHeaderText,
  allHeaderText
}) => {
  const multiselectCheckbox = ({
    checked,
    checkboxLabel,
    index,
    item,
    labelKey
  }) => (
    <Checkbox
      checked={checked}
      name="list-item-checkbox"
      label={checkboxLabel}
      id={`${item[labelKey]}-checkbox-${index}`}
      value={`${index}`}
    />
  );

  multiselectCheckbox.displayName = 'multiselectCheckbox';

  multiselectCheckbox.propTypes = {
    checked: PropTypes.bool.isRequired,
    checkboxLabel: PropTypes.string.isRequired,
    index: PropTypes.number.isRequired,
    item: PropTypes.objectOf(PropTypes.any).isRequired,
    labelKey: PropTypes.string.isRequired
  };

  return children({
    multiselectCheckbox,
    selectedSectionHeader: SectionHeader({
      text: selectedHeaderText,
      isCustomHeader: false
    }),
    remainingSectionHeader: SectionHeader({
      text: allHeaderText,
      isCustomHeader: false
    })
  });
};

DropdownMultiselect.displayName = 'DropdownMultiselect';

DropdownMultiselect.defaultProps = {
  allHeaderText: 'All Items',
  selectedHeaderText: 'Selected Items'
};

DropdownMultiselect.propTypes = {
  allHeaderText: PropTypes.string,
  children: PropTypes.node.isRequired,
  selectedHeaderText: PropTypes.string
};

export default DropdownMultiselect;
